'use client';

import { useEffect } from 'react';
import { ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT } from '../AttachmentsToolbar.keys';
import type { ATTACHMENTS_TOOLBAR_ACTION } from '../AttachmentsToolbar.keys';

const useListenForAttachmentsToolbarUpdates = (
  handler: (action: {
    type: (typeof ATTACHMENTS_TOOLBAR_ACTION)[keyof typeof ATTACHMENTS_TOOLBAR_ACTION];
    payload: any;
  }) => void,
) => {
  useEffect(() => {
    const handleAction = (e) => {
      handler(e?.detail);
    };

    document.addEventListener(
      ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT,
      handleAction,
    );

    return () => {
      document.removeEventListener(
        ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT,
        handleAction,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useListenForAttachmentsToolbarUpdates;
